export default "__VITE_ASSET__B$zD5qdu__"